import Localizer from 'localizer';
import ViewerSocialProfile from 'models/user/ViewerSocialProfile';

var RankingUtil = {
    /**
     * Gets the Internationalization for the rankings. If the ranking is not a number returns empty string.
     * @deprecated use `formatRankOfTotal` instead. (unless total count === 0).
     * @param {number} ranking
     * @param {string} place
     * @returns
     */
    getFormattedRanking: function(ranking, place) {
        //it will be 1st, 2nd, 3rd (translated), and just number for everything higher
        ranking = Number(ranking);
        if (isNaN(ranking) || ranking === 0 || ranking === null) {
            return '';
        }

        var placeString = place ? ' ' + place : '';

        var key = 'number_';
        switch (ranking) {
            case 1:
                key += 'st';
                return Localizer.localize(key, ranking) + placeString;
            case 2:
                key += 'nd';
                return Localizer.localize(key, ranking) + placeString;
            case 3:
                key += 'rd';
                return Localizer.localize(key, ranking) + placeString;
            default:
                return ranking + placeString;
        }
    },

    /**
     * format ranking string. ex `Rank 6 of 9`. namespace require: `challengewidget`
     *
     * fallbacks to `getFormattedRanking` when `total` is falsy
     *
     * @param {number} rank
     * @param {number} total
     */
    formatRankOfTotal: function(rank, total) {
        if (!total) {
            /** if there's no total */
            return RankingUtil.getFormattedRanking(rank);
        }
        return Localizer.localize('user_rank_n_of_rank_total_n', rank, total);
    },

    getCurrentMaxRanking: function(collection) {
        if (_.isUndefined(collection) || collection.length === 0) {
            return 0;
        }

        if (collection.length > 0) {
            if (_.isUndefined(collection.at(0).get('ranking'))) {
                return 1;
            }
        }

        for (var i = collection.length; i >= 0; i--) {
            var metric = collection.at(i);
            if (!_.isUndefined(metric.get('ranking'))) {
                return metric.get('ranking');
            }
        }
    },

    setRankingInCollection: function(collection) {
        if (_.isUndefined(collection)) {
            return 0;
        }

        var ranking = this.getCurrentMaxRanking(collection);
        for (var i = 0; i < collection.length; i++) {
            var metric = collection.at(i);
            if (!_.isUndefined(metric.get('ranking'))) {
                continue;
            }

            if (i == 0) {
                metric.set('ranking', 1);
                continue;
            }

            var prevMetric = collection.at(i - 1);
            if (metric.get('value') < prevMetric.get('value')) {
                ranking++;
            }
            metric.set('ranking', ranking);
        }
    }
};

export default RankingUtil;
